<script lang="ts">
import { usePrizesStore } from '@/stores/prizes'
import type { Prize } from '@/types'
import { PrizeCategories } from '@/utils/helper-objects'
import { defineComponent } from 'vue'

import ProductOverviewCard from '../cards/ProductOverviewCard.vue'
import AppCarousel from '../carousel/AppCarousel.vue'
import CarouselItem from '../carousel/CarouselItem.vue'

/**
 * A product overview section.
 */
export default defineComponent({
  components: {
    ProductOverviewCard,
    AppCarousel,
    CarouselItem,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  setup() {
    const prizesStore = usePrizesStore()

    return {
      prizesStore,
    }
  },
  computed: {
    prizes(): Array<Prize> {
      return this.prizesStore.prizesByCategory(PrizeCategories.Featured)
    },
  },
  async mounted() {
    void this.prizesStore.fetchPrizes()
  },
})
</script>

<template>
  <AppSection>
    <AppCarousel
      :title="$t('section.rewards.heading')"
      :icon="Icons.Ticket"
      :view-all-route="{ name: 'benefits' }"
    >
      <template #preamble>
        <p>{{ $t('section.rewards.excerpt') }}</p>
      </template>
      <CarouselItem
        v-for="(product, key) in prizesStore.productOverviews.reverse()"
        :key="key"
        class="w-full @xs/main:w-1/2 @md/main:w-1/3 @lg/main:w-1/4"
      >
        <ProductOverviewCard :product />
      </CarouselItem>
    </AppCarousel>

    <SectionGuard section="memberships">
      <AppButton
        v-if="$userStore.isLoggedIn"
        :route="{ name: 'benefits' }"
        :icon="Icons.ArrowRight"
        class="button-secondary button-secondary-light mx-auto mt-4 w-full font-semibold"
        :title="$t('button.see.all_benefits')"
      >
        {{ $t('button.see.all_benefits') }}
      </AppButton>
      <AppMembershipButton v-if="$userStore.isLoggedOut" />
    </SectionGuard>
  </AppSection>
</template>
